import { useReadContract } from "wagmi";
import {
  formatUnits,
  getAddress,
  isAddress,
  type Address as ViemAddress,
} from "viem";
import { env, getBaseChainFromEnv } from "@/config";

const erc20Abi = [
  {
    type: "function",
    name: "balanceOf",
    stateMutability: "view",
    inputs: [{ name: "owner", type: "address" }],
    outputs: [{ type: "uint256" }],
  },
  {
    type: "function",
    name: "decimals",
    stateMutability: "view",
    inputs: [],
    outputs: [{ type: "uint8" }],
  },
] as const;

export function mustAddress(value: string): ViemAddress {
  const v = (value ?? "").trim();
  if (!isAddress(v)) {
    throw new Error(`Address is invalid or missing: "${value}"`);
  }
  return getAddress(v);
}

export function useEvmBtnBalance(address?: string) {
  const CHAIN = getBaseChainFromEnv();

  const tokenAddress = mustAddress(env.baseTokenContractAddress);

  const ownerAddress =
    address && isAddress(address) ? getAddress(address) : undefined;

  const { data: decimals } = useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: "decimals",
    chainId: CHAIN.id,
  });

  const { data: rawBalance, isLoading } = useReadContract({
    address: tokenAddress,
    abi: erc20Abi,
    functionName: "balanceOf",
    args: ownerAddress ? [ownerAddress] : undefined,
    chainId: CHAIN.id,
    query: { enabled: Boolean(ownerAddress) },
  });

  const balance =
    rawBalance && typeof decimals === "number"
      ? formatUnits(rawBalance as bigint, decimals)
      : "0";

  return { balance, isLoading } as const;
}
